import { useContext } from "react";
import { minutesToTimeString } from "../main/WorkTimeView";
import { useGeneric } from "../useGeneric";
import AppContext from "../contexts/app-context";
import MonthlyAttendance from "./MonthlyAttendance";

export default function ExtraHours() {
  const { employeeID, setModal }: any = useContext(AppContext);
  const { loading, rows }: any = useGeneric({
    name: "extraTime",
    query: { employeeId: employeeID },
    reload: 1600,
    delay: 2,
  });

  const data = !loading && rows && rows?.length ? rows : false;

  const totalDiff = data?.[0]?.total_diff_with_manual;

  return (
    <div
      style={{
        fontSize: "12px",
        display: "flex",
        boxShadow: "0 0 2px rgba(0,0,0,.1)",
      }}
    >
      <div style={{ padding: "12px 16px", background: "whitesmoke" }}>
        BILANS GODZIN
      </div>
      {/* <div style={{ padding: "12px 16px" }}>W tym roku:</div> */}
      <div
        style={{
          padding: "12px 16px",
          fontWeight: "bold",
          color: data?.[0]?.total_diff_with_manual > 0 ? "green" : "brown",
        }}
      >
        {loading ? (
          <>...</>
        ) : data ? (
          (totalDiff > 0 ? "+ " : "") + minutesToTimeString(totalDiff)
        ) : (
          "(nie pobrano danych)"
        )}
      </div>
      <div>
        <button
          style={{ fontSize: "10px" }}
          onClick={() =>
            setModal({
              show: true,
              heading: <>Czas pracy</>,
              content: <MonthlyAttendance />,
              width: "wide",
              //   style: { height: "80vh" },
            })
          }
        >
          Przeglądaj
        </button>
      </div>
    </div>
  );
}
